module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Fy1id2/tc-custom/9781504010047.jpg?1701240362521",
      "alt": "This image is the cover for the book Perfect Scoundrel, The Sommerville Novels"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Perfect Scoundrel, The Sommerville Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In the follow-up to "), _c('i', [_vm._v("For All Eternity")]), _vm._v(", a perfect scoundrel finds perfect love")]), _c('br'), _c('br'), _vm._v(" Lord Quentin Somerville is smitten with society’s most sought-after beauty. But as a debt-ridden second son, he knows his only chance of winning such a prize is to resort to trickery, and he concocts a plan to trap her into marrying him. But his plan to seduce Clarissa Edwardes at a masked ball backfires when he discovers that the woman in his arms isn’t the one he desires."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" When Clarissa falls ill on the day of the ball, and the costume of her spinster stepsister, Jane Wentworth, meets with disaster, Clarissa hatches a plan of her own: Jane must go to the masquerade disguised as Clarissa. As planned, Jane is mistaken for Clarissa by everyone, including Quentin. Jane, who is secretly in love with Quentin, is thrilled by his notice. When her daring charade leads to a stolen kiss, she isn’t prepared for his passionate response—or for the ensuing scandal. With Jane’s honor compromised, Quentin proposes under the threat of being cut off by his father. Furious at being deceived, the young noble vows to continue his dissolute life in London and banishes Jane to his dreary estate in Worcestershire. But he underestimates the charms—and determination—of his wife, who has plans of her own."), _c('br'), _c('br', {
    attrs: {
      "clear": "all"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Heather Cullman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Heather Cullman has a degree in fashion and design and has always wanted to be a writer. She lives with her husband, a lawyer, in Long Beach, California. She is the author of eight historical romances.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0